import React from "react";

export const SideNav = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16">
      <g id="menu-right-alt" transform="translate(0)">
        <path
          id="Path_1"
          data-name="Path 1"
          d="M4,6.522A1.511,1.511,0,0,1,5.5,5h21a1.523,1.523,0,0,1,0,3.045H5.5A1.511,1.511,0,0,1,4,6.522Z"
          transform="translate(-4 -5)"
        />
        <path
          id="Path_2"
          data-name="Path 2"
          d="M4,18.522A1.511,1.511,0,0,1,5.5,17h21a1.523,1.523,0,0,1,0,3.045H5.5A1.511,1.511,0,0,1,4,18.522Z"
          transform="translate(-4 -4.045)"
        />
        <path
          id="Path_3"
          data-name="Path 3"
          d="M11.523,11a1.522,1.522,0,0,0,0,3.045H23.7A1.522,1.522,0,0,0,23.7,11Z"
          transform="translate(-1.225 -4.523)"
        />
      </g>
    </svg>
  );
};

export const MyDashBoardIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23.223" height="23.223" viewBox="0 0 23.223 23.223">
      <path
        id="dashboard_FILL0_wght400_GRAD0_opsz24"
        d="M132.9-832.259V-840h10.321v7.741ZM120-827.1V-840h10.321v12.9Zm12.9,10.321v-12.9h10.321v12.9Zm-12.9,0v-7.741h10.321v7.741Zm1.58-11.9h7.161v-9.741H121.58Zm12.9,10.321h7.161V-828.1h-7.161Zm0-15.482h7.161v-4.58h-7.161Zm-12.9,15.482h7.161v-4.58H121.58Z"
        transform="translate(-120 840)"
        fill="#333"
      />
    </svg>
  );
};

export const MachineTabIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24.081" height="24.069" viewBox="0 0 24.081 24.069">
      <g id="Group_7649" data-name="Group 7649" transform="translate(-0.563 -0.558)">
        <path
          id="Path_19180"
          data-name="Path 19180"
          d="M18.713,31.367a.438.438,0,0,0-.437.437v.9a.531.531,0,0,1-.533.528H16.7a2.044,2.044,0,0,0-1.781,3.065l.52.9a.527.527,0,0,1,.052.4.5.5,0,0,1-.244.319l-2.244,1.284a.526.526,0,0,1-.406.052.513.513,0,0,1-.323-.249l-.52-.9a2.058,2.058,0,0,0-3.554,0l-.52.9a.532.532,0,0,1-.729.192L4.711,37.907a.511.511,0,0,1-.244-.323.538.538,0,0,1,.052-.4l.52-.9a2.008,2.008,0,0,0,.009-2.035,2.036,2.036,0,0,0-1.786-1.03H2.223a.531.531,0,0,1-.533-.528V30.114a.531.531,0,0,1,.533-.528H3.262a2.044,2.044,0,0,0,1.781-3.065l-.52-.9a.527.527,0,0,1-.052-.4.5.5,0,0,1,.244-.319L6.96,23.622a.532.532,0,0,1,.729.2l.175.3a.437.437,0,1,0,.755-.441l-.175-.3a1.4,1.4,0,0,0-1.917-.515L4.284,24.146a1.4,1.4,0,0,0-.515,1.912l.52.9a1.131,1.131,0,0,1,0,1.161,1.176,1.176,0,0,1-1.03.594H2.218a1.4,1.4,0,0,0-1.406,1.4V32.69a1.4,1.4,0,0,0,1.406,1.4H3.258a1.176,1.176,0,0,1,1.03.594,1.141,1.141,0,0,1,0,1.161l-.52.9a1.4,1.4,0,0,0-.14,1.065,1.369,1.369,0,0,0,.655.851l2.244,1.284a1.4,1.4,0,0,0,1.917-.515l.52-.9a1.192,1.192,0,0,1,2.052,0l.52.9a1.378,1.378,0,0,0,.856.655,1.51,1.51,0,0,0,.367.048,1.408,1.408,0,0,0,.7-.188L15.7,38.662a1.4,1.4,0,0,0,.515-1.912l-.52-.9a1.131,1.131,0,0,1,0-1.161,1.176,1.176,0,0,1,1.03-.594h1.039a1.4,1.4,0,0,0,1.406-1.4v-.9a.438.438,0,0,0-.437-.437Z"
          transform="translate(0 -15.757)"
          fill="#333"
        />
        <path
          id="Path_19180_-_Outline"
          data-name="Path 19180 - Outline"
          d="M7.229,22.425a1.652,1.652,0,0,1,1.433.828l.174.3a.687.687,0,1,1-1.188.692l-.175-.3a.286.286,0,0,0-.247-.144.276.276,0,0,0-.139.038L4.834,25.126a.251.251,0,0,0-.12.161.277.277,0,0,0,.027.211l.519.9a2.294,2.294,0,0,1-2,3.44H2.223a.281.281,0,0,0-.283.278V32.69a.281.281,0,0,0,.283.278H3.262a2.283,2.283,0,0,1,2,1.156,2.257,2.257,0,0,1-.009,2.285l-.519.9a.286.286,0,0,0-.027.214.262.262,0,0,0,.126.168L7.08,38.974a.291.291,0,0,0,.145.039.278.278,0,0,0,.242-.138l.521-.9a2.308,2.308,0,0,1,3.986,0l.522.9a.263.263,0,0,0,.167.128h.005a.279.279,0,0,0,.214-.029l2.25-1.287a.251.251,0,0,0,.12-.161.277.277,0,0,0-.027-.211l-.519-.9a2.294,2.294,0,0,1,2-3.44h1.039a.281.281,0,0,0,.283-.278v-.9a.687.687,0,0,1,.653-.686l.021-.005h.031a.687.687,0,0,1,.687.687v.9a1.656,1.656,0,0,1-1.656,1.651H16.722a.929.929,0,0,0-.814.469.882.882,0,0,0,0,.909l.521.9a1.625,1.625,0,0,1,.165,1.25,1.643,1.643,0,0,1-.771,1l-2.246,1.284a1.662,1.662,0,0,1-.823.221,1.745,1.745,0,0,1-.427-.055,1.633,1.633,0,0,1-1.012-.773l-.519-.894a.942.942,0,0,0-1.62,0l-.519.895a1.656,1.656,0,0,1-2.257.607L4.155,38.879a1.613,1.613,0,0,1-.772-1,1.643,1.643,0,0,1,.165-1.255l.519-.9a.9.9,0,0,0,0-.912.929.929,0,0,0-.813-.468H2.218A1.656,1.656,0,0,1,.563,32.69V30.114a1.656,1.656,0,0,1,1.656-1.651H3.258a.929.929,0,0,0,.814-.469.882.882,0,0,0,0-.909l-.521-.9a1.625,1.625,0,0,1-.165-1.25,1.643,1.643,0,0,1,.771-1L6.4,22.645A1.666,1.666,0,0,1,7.229,22.425Zm1.012,1.661A.188.188,0,0,0,8.4,23.8l-.175-.3a1.152,1.152,0,0,0-1-.577,1.165,1.165,0,0,0-.577.154L4.408,24.363a1.145,1.145,0,0,0-.537.7,1.13,1.13,0,0,0,.113.87l.521.9a1.374,1.374,0,0,1,0,1.413,1.423,1.423,0,0,1-1.246.717H2.218a1.155,1.155,0,0,0-1.156,1.151V32.69a1.155,1.155,0,0,0,1.156,1.151H3.258A1.424,1.424,0,0,1,4.5,34.56,1.391,1.391,0,0,1,4.5,35.973l-.518.9a1.147,1.147,0,0,0-.115.876,1.118,1.118,0,0,0,.535.7l2.246,1.285a1.165,1.165,0,0,0,.577.154,1.151,1.151,0,0,0,1-.576l.52-.9a1.442,1.442,0,0,1,2.484,0l.52.9a1.136,1.136,0,0,0,.7.539,1.247,1.247,0,0,0,.3.04,1.161,1.161,0,0,0,.575-.155l2.244-1.284a1.145,1.145,0,0,0,.537-.7,1.13,1.13,0,0,0-.113-.87l-.521-.9a1.374,1.374,0,0,1,0-1.413,1.423,1.423,0,0,1,1.246-.717h1.039a1.155,1.155,0,0,0,1.156-1.151v-.9a.187.187,0,0,0-.162-.185l-.011,0h-.031a.187.187,0,0,0-.187.187v.9a.781.781,0,0,1-.783.778H16.7a1.789,1.789,0,0,0-1.569.9,1.767,1.767,0,0,0,0,1.785l.52.9a.779.779,0,0,1,.078.585.753.753,0,0,1-.365.475l-2.242,1.282a.783.783,0,0,1-.595.077.768.768,0,0,1-.476-.367l-.518-.893a1.808,1.808,0,0,0-3.121,0l-.52.9a.778.778,0,0,1-.676.389.791.791,0,0,1-.394-.106L4.587,38.124a.759.759,0,0,1-.363-.479.783.783,0,0,1,.078-.586l.52-.9a1.763,1.763,0,0,0,.009-1.785,1.789,1.789,0,0,0-1.569-.905H2.223a.781.781,0,0,1-.783-.778V30.114a.781.781,0,0,1,.783-.778H3.262a1.789,1.789,0,0,0,1.569-.9,1.767,1.767,0,0,0,0-1.785l-.52-.9a.779.779,0,0,1-.078-.585.753.753,0,0,1,.365-.475L6.836,23.4a.774.774,0,0,1,.39-.105.787.787,0,0,1,.68.394l.174.3A.185.185,0,0,0,8.241,24.087Z"
          transform="translate(0 -15.757)"
          fill="#333"
        />
        <path
          id="Path_19181"
          data-name="Path 19181"
          d="M45.671,5.581h-.834a.863.863,0,0,1-.751-.428.8.8,0,0,1,0-.821l.415-.707a1.179,1.179,0,0,0,.122-.908,1.2,1.2,0,0,0-.568-.733L42.266.967a1.221,1.221,0,0,0-1.65.437L40.2,2.11a.867.867,0,0,1-1.484,0L38.3,1.4a1.222,1.222,0,0,0-1.65-.437L34.856,1.984a1.194,1.194,0,0,0-.445,1.642l.415.707a.8.8,0,0,1,0,.821.853.853,0,0,1-.751.428h-.834a1.208,1.208,0,0,0-1.214,1.2v2.03a1.211,1.211,0,0,0,1.214,1.2h.834a.863.863,0,0,1,.751.428.8.8,0,0,1,0,.821l-.415.707a1.18,1.18,0,0,0-.122.908,1.2,1.2,0,0,0,.568.733l1.794,1.017a1.221,1.221,0,0,0,1.65-.437l.415-.707a.867.867,0,0,1,1.484,0l.415.707a1.209,1.209,0,0,0,1.052.594,1.254,1.254,0,0,0,.6-.157l1.794-1.017a1.194,1.194,0,0,0,.445-1.642l-.415-.707a.8.8,0,0,1,0-.821.853.853,0,0,1,.751-.428h.834a1.208,1.208,0,0,0,1.214-1.2V6.782a1.211,1.211,0,0,0-1.214-1.2Zm.341,3.231a.336.336,0,0,1-.341.327h-.834a1.708,1.708,0,0,0-1.506.869A1.669,1.669,0,0,0,43.34,11.7l.415.707a.31.31,0,0,1,.035.24.34.34,0,0,1-.157.2l-1.794,1.017a.34.34,0,0,1-.467-.122l-.415-.707a1.743,1.743,0,0,0-3,0l-.415.707a.345.345,0,0,1-.467.122l-1.794-1.017a.316.316,0,0,1-.157-.2.309.309,0,0,1,.035-.24l.415-.707a1.669,1.669,0,0,0,.009-1.694,1.708,1.708,0,0,0-1.506-.869h-.834a.333.333,0,0,1-.341-.327V6.782a.336.336,0,0,1,.341-.327h.834a1.708,1.708,0,0,0,1.506-.869,1.669,1.669,0,0,0-.009-1.694l-.415-.707a.309.309,0,0,1-.035-.24.34.34,0,0,1,.157-.2l1.794-1.017a.344.344,0,0,1,.467.122l.415.707a1.743,1.743,0,0,0,3,0l.415-.707a.345.345,0,0,1,.467-.122l1.794,1.017a.316.316,0,0,1,.157.2.31.31,0,0,1-.035.24l-.415.707a1.669,1.669,0,0,0-.009,1.694,1.708,1.708,0,0,0,1.506.869h.834a.333.333,0,0,1,.341.327Z"
          transform="translate(-22.496 0)"
          fill="#333"
        />
        <path
          id="Path_19181_-_Outline"
          data-name="Path 19181 - Outline"
          d="M37.251.558a1.476,1.476,0,0,1,1.266.718l.415.708a.617.617,0,0,0,1.053,0l.415-.708A1.467,1.467,0,0,1,41.665.558h0a1.469,1.469,0,0,1,.724.191l1.794,1.017a1.442,1.442,0,0,1,.686.886,1.427,1.427,0,0,1-.148,1.1l-.415.707a.553.553,0,0,0,0,.571.614.614,0,0,0,.533.3h.834a1.46,1.46,0,0,1,1.468,1.451v2.03a1.459,1.459,0,0,1-1.464,1.451h-.834a.606.606,0,0,0-.534.3.554.554,0,0,0,0,.569l.415.708a1.444,1.444,0,0,1-.537,1.985l-1.795,1.017a1.5,1.5,0,0,1-.726.19,1.464,1.464,0,0,1-1.268-.718l-.414-.706a.617.617,0,0,0-1.053,0l-.415.708a1.471,1.471,0,0,1-1.989.527l-1.794-1.017a1.442,1.442,0,0,1-.686-.886,1.427,1.427,0,0,1,.148-1.1l.415-.707a.553.553,0,0,0,0-.571.614.614,0,0,0-.533-.3h-.834a1.459,1.459,0,0,1-1.464-1.451V6.782a1.459,1.459,0,0,1,1.464-1.451h.834a.606.606,0,0,0,.534-.3.554.554,0,0,0,0-.569L34.2,3.752a1.444,1.444,0,0,1,.537-1.985L36.528.749A1.466,1.466,0,0,1,37.251.558ZM39.458,2.78a1.1,1.1,0,0,1-.958-.543l-.414-.707a.971.971,0,0,0-1.311-.346L34.98,2.2a.944.944,0,0,0-.353,1.3l.415.707a1.056,1.056,0,0,1,.006,1.071,1.1,1.1,0,0,1-.968.555h-.834a.958.958,0,0,0-.964.951v2.03a.958.958,0,0,0,.964.951h.834a1.111,1.111,0,0,1,.966.551,1.051,1.051,0,0,1,0,1.074l-.415.708a.93.93,0,0,0-.1.717.946.946,0,0,0,.45.581l1.794,1.017a.971.971,0,0,0,1.311-.345l.415-.708a1.117,1.117,0,0,1,1.916,0l.414.707a.964.964,0,0,0,.837.47,1,1,0,0,0,.483-.127l1.791-1.015a.944.944,0,0,0,.353-1.3l-.415-.707a1.056,1.056,0,0,1-.006-1.071,1.1,1.1,0,0,1,.968-.555h.834a.958.958,0,0,0,.964-.951V6.782a.958.958,0,0,0-.964-.951h-.838a1.112,1.112,0,0,1-.966-.551,1.051,1.051,0,0,1,0-1.074L44.29,3.5a.93.93,0,0,0,.1-.717.946.946,0,0,0-.45-.581L42.142,1.184a.971.971,0,0,0-1.311.345l-.415.708A1.1,1.1,0,0,1,39.458,2.78ZM37.252,1.431a.587.587,0,0,1,.511.294l.413.7a1.493,1.493,0,0,0,2.564,0l.414-.707a.587.587,0,0,1,.511-.291.6.6,0,0,1,.295.078l1.794,1.017a.566.566,0,0,1,.214.785l-.415.707a1.422,1.422,0,0,0-.008,1.443,1.463,1.463,0,0,0,1.289.743h.834a.585.585,0,0,1,.591.577v2.03a.585.585,0,0,1-.591.577h-.834a1.462,1.462,0,0,0-1.289.742,1.423,1.423,0,0,0,.007,1.444l.415.707a.562.562,0,0,1,.061.43.59.59,0,0,1-.269.351l-.007,0-1.794,1.017a.6.6,0,0,1-.3.079.588.588,0,0,1-.511-.3l-.413-.7a1.493,1.493,0,0,0-2.564,0l-.414.707a.587.587,0,0,1-.511.291.6.6,0,0,1-.295-.078l-1.794-1.017a.566.566,0,0,1-.214-.785l.415-.707a1.422,1.422,0,0,0,.008-1.443,1.463,1.463,0,0,0-1.289-.743h-.834a.585.585,0,0,1-.591-.577V6.782a.585.585,0,0,1,.591-.577h.834a1.462,1.462,0,0,0,1.289-.742,1.423,1.423,0,0,0-.007-1.444l-.415-.707a.561.561,0,0,1-.061-.43.589.589,0,0,1,.269-.35l.007,0,1.794-1.017A.613.613,0,0,1,37.252,1.431Zm2.206,2.226a1.969,1.969,0,0,1-1.713-.974l-.415-.708a.089.089,0,0,0-.078-.044.109.109,0,0,0-.053.014L35.412,2.958a.094.094,0,0,0-.043.049.06.06,0,0,0,.009.05l.415.708A1.917,1.917,0,0,1,35.8,5.71a1.956,1.956,0,0,1-1.723.994h-.834a.087.087,0,0,0-.091.077v2.03a.084.084,0,0,0,.091.077h.834a1.957,1.957,0,0,1,1.724,1,1.916,1.916,0,0,1-.01,1.944l-.415.707a.06.06,0,0,0-.009.05.067.067,0,0,0,.037.046l1.8,1.018a.1.1,0,0,0,.048.012.089.089,0,0,0,.078-.041l.417-.71a1.993,1.993,0,0,1,3.426,0l.415.708a.089.089,0,0,0,.078.046.1.1,0,0,0,.048-.013L43.5,12.636a.1.1,0,0,0,.043-.05.06.06,0,0,0-.009-.05l-.415-.708a1.917,1.917,0,0,1-.01-1.945,1.956,1.956,0,0,1,1.723-.994h.834a.087.087,0,0,0,.091-.077V6.782a.084.084,0,0,0-.091-.077h-.834a1.957,1.957,0,0,1-1.724-1,1.916,1.916,0,0,1,.011-1.944l.415-.707a.06.06,0,0,0,.009-.05.067.067,0,0,0-.037-.046l-1.8-1.018a.1.1,0,0,0-.048-.012.089.089,0,0,0-.078.041l-.417.71A1.97,1.97,0,0,1,39.458,3.657Z"
          transform="translate(-22.496 0)"
          fill="#333"
        />
        <path
          id="Path_19182"
          data-name="Path 19182"
          d="M50.743,14.875A3.056,3.056,0,1,0,53.8,17.931,3.06,3.06,0,0,0,50.743,14.875Zm0,5.239a2.183,2.183,0,1,1,2.183-2.183A2.184,2.184,0,0,1,50.743,20.114Z"
          transform="translate(-33.777 -10.136)"
          fill="#333"
        />
        <path
          id="Path_19182_-_Outline"
          data-name="Path 19182 - Outline"
          d="M50.743,14.625a3.306,3.306,0,1,1-3.306,3.306A3.31,3.31,0,0,1,50.743,14.625Zm0,6.113a2.806,2.806,0,1,0-2.806-2.806A2.81,2.81,0,0,0,50.743,20.738Zm0-5.239a2.433,2.433,0,1,1-2.433,2.433A2.436,2.436,0,0,1,50.743,15.5Zm0,4.366a1.933,1.933,0,1,0-1.933-1.933A1.935,1.935,0,0,0,50.743,19.864Z"
          transform="translate(-33.777 -10.136)"
          fill="#333"
        />
        <path
          id="Path_19183"
          data-name="Path 19183"
          d="M23.492,40.737a3.108,3.108,0,0,1,.437.031.434.434,0,0,0,.489-.375.441.441,0,0,0-.375-.493,4.074,4.074,0,0,0-.55-.039,3.929,3.929,0,1,0,3.929,4.03.441.441,0,0,0-.423-.45h-.013a.435.435,0,0,0-.437.423,3.057,3.057,0,1,1-3.056-3.131Z"
          transform="translate(-13.511 -28.139)"
          fill="#333"
        />
        <path
          id="Path_19183_-_Outline"
          data-name="Path 19183 - Outline"
          d="M23.492,39.609a4.344,4.344,0,0,1,.584.042.688.688,0,0,1-.09,1.37.7.7,0,0,1-.089-.006,2.866,2.866,0,0,0-.405-.029h-.166A2.806,2.806,0,1,0,26.3,43.856a.687.687,0,0,1,.687-.667h.022a.694.694,0,0,1,.664.7,4.18,4.18,0,1,1-4.179-4.284Zm.494.912a.183.183,0,0,0,.184-.161.191.191,0,0,0-.163-.214,3.835,3.835,0,0,0-.514-.037,3.679,3.679,0,1,0,3.679,3.773.191.191,0,0,0-.179-.193h-.008a.185.185,0,0,0-.187.178,3.307,3.307,0,1,1-3.306-3.385h.235V40.5c.08.006.159.014.237.025Z"
          transform="translate(-13.511 -28.139)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const ExpandIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-arrows-fullscreen"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707m0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707m-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707"
      />
    </svg>
  );
};

export const BreadCrumbIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-chevron-right"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
      ></path>
    </svg>
  );
};

export const EyeIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24.015" height="15.336" viewBox="0 0 24.015 15.336">
      <g id="Group_5530" data-name="Group 5530" transform="translate(-6.075 -22)">
        <path
          id="Path_16648"
          data-name="Path 16648"
          d="M25.791,25.007A12.757,12.757,0,0,0,18.082,22a12.757,12.757,0,0,0-7.709,3.007A24.009,24.009,0,0,0,6.3,29.025a1.028,1.028,0,0,0,0,1.285,25.145,25.145,0,0,0,4.073,4.018,12.881,12.881,0,0,0,7.709,3.007,12.819,12.819,0,0,0,7.709-3.007,24.009,24.009,0,0,0,4.073-4.018,1.028,1.028,0,0,0,0-1.285A22.056,22.056,0,0,0,25.791,25.007ZM18.082,35.215c-5.358,0-9.561-4.385-10.491-5.561.957-1.175,5.133-5.561,10.491-5.561s9.51,4.385,10.439,5.561C27.592,30.83,23.44,35.215,18.082,35.215Z"
          fill="#fff"
        ></path>
        <path
          id="Path_16649"
          data-name="Path 16649"
          d="M36.921,32a4.921,4.921,0,1,0,4.921,4.921A4.935,4.935,0,0,0,36.921,32Zm0,8.748a3.827,3.827,0,1,1,3.827-3.827A3.838,3.838,0,0,1,36.921,40.748Z"
          transform="translate(-18.838 -7.266)"
          fill="#fff"
        ></path>
        <path
          id="Path_16650"
          data-name="Path 16650"
          d="M40.9,43.388h1.093a1.4,1.4,0,0,1,1.394-1.394V40.9A2.5,2.5,0,0,0,40.9,43.388Z"
          transform="translate(-25.305 -13.733)"
          fill="#fff"
        ></path>
      </g>
    </svg>
  );
};

export const InfoIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16">
      <path
        fill="#fff"
        d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm1 10H7V7h2v6z"
      />
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-download"
      viewBox="0 0 16 16"
    >
      <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
      <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
      <g id="Group_3141" data-name="Group 3141" transform="translate(-24.2 -24.2)">
        <path
          id="Path_14272"
          data-name="Path 14272"
          d="M29.781,48.2H42.619A5.6,5.6,0,0,0,48.2,42.619h0V38.991a.93.93,0,0,0-1.86,0v3.628a3.732,3.732,0,0,1-3.721,3.721H29.781a3.732,3.732,0,0,1-3.721-3.721V29.781a3.732,3.732,0,0,1,3.721-3.721h3.628a.93.93,0,0,0,0-1.86H29.781A5.6,5.6,0,0,0,24.2,29.781V42.619A5.6,5.6,0,0,0,29.781,48.2Z"
          fill="#333"
        ></path>
        <path
          id="Path_14273"
          data-name="Path 14273"
          d="M50.482,25.677l-9.488,9.488a.9.9,0,0,0-.233.419l-1.3,4.651A.93.93,0,0,0,40.11,41.4a.951.951,0,0,0,.512,0l4.651-1.3a1.886,1.886,0,0,0,.419-.233l9.535-9.488a3.313,3.313,0,0,0,0-4.7,3.369,3.369,0,0,0-4.744,0ZM41.645,39.165l.465-1.581,1.163,1.163Zm12.186-10.14L45.04,37.816,42.994,35.77l8.791-8.791a1.462,1.462,0,0,1,2.047.14A1.478,1.478,0,0,1,53.831,29.026Z"
          transform="translate(-8.142 -0.267)"
          fill="#333"
        ></path>
      </g>
    </svg>
  );
};

export const ListOptionsIcon = ({ active = false }) => {
  const fill = active ? "#ca353b" : "#333";
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M4 6h16a1 1 0 0 0 0-2H4a1 1 0 0 0 0 2Zm0 5h16a1 1 0 0 0 0-2H4a1 1 0 0 0 0 2Zm0 5h16a1 1 0 0 0 0-2H4a1 1 0 0 0 0 2Z"
        fill={fill}
      />
      <circle cx="19" cy="6" r="2.5" fill={active ? "#ca353b" : "none"} stroke={active ? "#ca353b" : "none"} />
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.24" height="24" viewBox="0 0 20.24 24">
      <g id="Group_4462" data-name="Group 4462" transform="translate(-108.999 -172.003)">
        <g id="trash-can-10416" transform="translate(108.999 172.003)">
          <path
            id="Path_156"
            data-name="Path 156"
            d="M48.776,52.948H38.467a2.343,2.343,0,0,1-2.317-2.228L35.123,32.83a.81.81,0,0,1,.212-.6.777.777,0,0,1,.571-.251h15.43a.779.779,0,0,1,.571.251.812.812,0,0,1,.213.6L51.093,50.72A2.343,2.343,0,0,1,48.776,52.948ZM36.738,33.583l.979,17.043a.759.759,0,0,0,.75.722H48.776a.758.758,0,0,0,.75-.721l.979-17.044Z"
            transform="translate(-33.502 -28.948)"
            fill="#ca353b"
          ></path>
          <path
            id="Path_157"
            data-name="Path 157"
            d="M37.169,33.581H18.5a.8.8,0,0,1,0-1.6H37.17a.8.8,0,0,1,0,1.6Z"
            transform="translate(-17.714 -28.946)"
            fill="#ca353b"
          ></path>
          <path
            id="Path_158"
            data-name="Path 158"
            d="M87.407,4.635H80.226a.792.792,0,0,1-.785-.8V2.344A2.324,2.324,0,0,1,81.74,0h4.153a2.324,2.324,0,0,1,2.3,2.344V3.835A.792.792,0,0,1,87.407,4.635Zm-6.4-1.6h5.611V2.344a.737.737,0,0,0-.729-.744H81.74a.737.737,0,0,0-.729.744v.691Z"
            transform="translate(-73.697)"
            fill="#ca353b"
          ></path>
          <path
            id="Path_159"
            data-name="Path 159"
            d="M156.254,88.019h-.047a.8.8,0,0,1-.737-.846l.647-11.265a.786.786,0,0,1,.829-.752.8.8,0,0,1,.737.845l-.647,11.265A.791.791,0,0,1,156.254,88.019Z"
            transform="translate(-142.648 -68.021)"
            fill="#ca353b"
          ></path>
          <path
            id="Path_160"
            data-name="Path 160"
            d="M75.049,88.02a.791.791,0,0,1-.782-.753L73.62,76a.785.785,0,1,1,1.566-.094l.647,11.265a.8.8,0,0,1-.737.846Z"
            transform="translate(-68.416 -68.022)"
            fill="#ca353b"
          ></path>
          <path
            id="Path_161"
            data-name="Path 161"
            d="M118.8,88.024a.792.792,0,0,1-.785-.8V75.959a.785.785,0,1,1,1.569,0V87.224A.792.792,0,0,1,118.8,88.024Z"
            transform="translate(-108.685 -68.026)"
            fill="#ca353b"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export const RightArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-chevron-right"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
      />
    </svg>
  );
};

export const VideoIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="31.095" height="22.366" viewBox="0 0 31.095 22.366">
      <g id="Group_6125" data-name="Group 6125" transform="translate(-477.453 -257.817)">
        <path
          id="Path_17557"
          data-name="Path 17557"
          d="M22.822,13.991a2.925,2.925,0,0,0,1.037,2.138l1.455,1.222a2.909,2.909,0,0,0,4.78-2.226V7.241a2.909,2.909,0,0,0-4.78-2.226L23.86,6.237a2.89,2.89,0,0,0-1.037,2.124m0,5.63v1.556A5.819,5.819,0,0,1,17,21.366H6.819A5.819,5.819,0,0,1,1,15.547V6.819A5.819,5.819,0,0,1,6.819,1H17a5.819,5.819,0,0,1,5.819,5.819V8.361m0,5.63V8.361"
          transform="translate(477.453 257.817)"
          fill="none"
          stroke="#333"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        ></path>
      </g>
    </svg>
  );
};

export const SimApps = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
      <g id="Group_2822" data-name="Group 2822" transform="translate(-1848 -23)">
        <g id="Group_2823" data-name="Group 2823" transform="translate(-2144 -1086)">
          <g id="Group_2826" data-name="Group 2826" transform="translate(-4)">
            <g id="Path_14087" data-name="Path 14087" transform="translate(4016 1129)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14088" data-name="Path 14088" transform="translate(4016 1119)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14093" data-name="Path 14093" transform="translate(4016 1109)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
          </g>
          <g id="Group_2825" data-name="Group 2825" transform="translate(-2)">
            <g id="Path_14086" data-name="Path 14086" transform="translate(4004 1129)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14089" data-name="Path 14089" transform="translate(4004 1119)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14092" data-name="Path 14092" transform="translate(4004 1109)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
          </g>
          <g id="Group_2824" data-name="Group 2824">
            <g id="Path_14085" data-name="Path 14085" transform="translate(3992 1129)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14090" data-name="Path 14090" transform="translate(3992 1119)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14091" data-name="Path 14091" transform="translate(3992 1109)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21.297" height="19.35" viewBox="0 0 21.297 19.35">
      <g id="Group_4203" data-name="Group 4203" transform="translate(0 -1)">
        <path
          id="Path_15265"
          data-name="Path 15265"
          d="M17.51,12.814a3.768,3.768,0,1,1-3.79,3.768A3.782,3.782,0,0,1,17.51,12.814Zm0,1.825a1.942,1.942,0,1,0,1.962,1.942A1.956,1.956,0,0,0,17.51,14.64ZM8.616,15.717a.913.913,0,1,1,0,1.825H.948a.913.913,0,1,1,0-1.825ZM3.788,1A3.768,3.768,0,1,1,0,4.769,3.783,3.783,0,0,1,3.788,1Zm0,1.825A1.942,1.942,0,1,0,5.751,4.769,1.956,1.956,0,0,0,3.788,2.825ZM19.7,3.921a.913.913,0,0,1,0,1.825H12.037a.913.913,0,0,1,0-1.825Z"
          fill="#fff"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
};
export const FilterIconsNew = () => {
  return (
    <svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 1H1V3.89453C1 4.18512 1.11156 4.47593 1.31131 4.6771L7.06369 10.7347C7.26344 10.9358 7.375 11.2266 7.375 11.5172V16.6471L11.625 20V11.5172C11.625 11.2266 11.7366 10.9358 11.9363 10.7347L17.6887 4.6771C17.7875 4.57509 17.866 4.45346 17.9194 4.31911C17.9729 4.18475 18.0003 4.04018 18 3.89453V1Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </svg>
  );
};

export const PDFIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="29.384" height="30.912" viewBox="0 0 29.384 30.912">
      <path
        id="pdf"
        d="M17.735,1.091V2.826c0,2.556,0,3.833.5,4.807a4.466,4.466,0,0,0,1.994,1.993c.977.5,2.255.5,4.811.5h1.737m-9.04-9.037A18.079,18.079,0,0,0,15.223,1H12.258C8.85,1,7.146,1,5.844,1.669A6.046,6.046,0,0,0,3.185,4.317c-.663,1.308-.663,3.012-.663,6.42v3.956m15.213-13.6a3.687,3.687,0,0,1,.421.076,6.149,6.149,0,0,1,1.759.73,13.192,13.192,0,0,1,2.194,1.948l1.9,1.917a12.61,12.61,0,0,1,1.956,2.191,5.878,5.878,0,0,1,.808,2.176m0,0a18.587,18.587,0,0,1,.088,2.51v2.054M1,29.906V19.256H3.282a3.8,3.8,0,0,1,0,7.607H1m21.3,3.043V19.256h6.085m0,6.085H22.3M11.649,19.256V29.906h.761a5.325,5.325,0,0,0,0-10.649Z"
        transform="translate(0 0.007)"
        fill="none"
        stroke="#333"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      ></path>
    </svg>
  );
};

export const CSVIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-filetype-csv"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.517 14.841a1.13 1.13 0 0 0 .401.823q.195.162.478.252.284.091.665.091.507 0 .859-.158.354-.158.539-.44.187-.284.187-.656 0-.336-.134-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.566-.21l-.621-.144a1 1 0 0 1-.404-.176.37.37 0 0 1-.144-.299q0-.234.185-.384.188-.152.512-.152.214 0 .37.068a.6.6 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.2-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.439 0-.776.15-.337.149-.527.421-.19.273-.19.639 0 .302.122.524.124.223.352.367.228.143.539.213l.618.144q.31.073.463.193a.39.39 0 0 1 .152.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.167.07-.413.07-.175 0-.32-.04a.8.8 0 0 1-.248-.115.58.58 0 0 1-.255-.384zM.806 13.693q0-.373.102-.633a.87.87 0 0 1 .302-.399.8.8 0 0 1 .475-.137q.225 0 .398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.4 1.4 0 0 0-.489-.272 1.8 1.8 0 0 0-.606-.097q-.534 0-.911.223-.375.222-.572.632-.195.41-.196.979v.498q0 .568.193.976.197.407.572.626.375.217.914.217.439 0 .785-.164t.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.8.8 0 0 1-.118.363.7.7 0 0 1-.272.25.9.9 0 0 1-.401.087.85.85 0 0 1-.478-.132.83.83 0 0 1-.299-.392 1.7 1.7 0 0 1-.102-.627zm8.239 2.238h-.953l-1.338-3.999h.917l.896 3.138h.038l.888-3.138h.879z"
      />
    </svg>
  );
};

export const AddImageIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.33317 6.66667H22.6665V16H25.3332V6.66667C25.3332 5.196 24.1372 4 22.6665 4H5.33317C3.8625 4 2.6665 5.196 2.6665 6.66667V22.6667C2.6665 24.1373 3.8625 25.3333 5.33317 25.3333H15.9998V22.6667H5.33317V6.66667Z"
        fill="#0658C2"
      ></path>
      <path d="M10.6665 14.6667L6.6665 20H21.3332L15.9998 12L11.9998 17.3333L10.6665 14.6667Z" fill="#0658C2"></path>
      <path
        d="M25.3332 18.6667H22.6665V22.6667H18.6665V25.3333H22.6665V29.3333H25.3332V25.3333H29.3332V22.6667H25.3332V18.6667Z"
        fill="#0658C2"
      ></path>
    </svg>
  );
};

export const SearchesCIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20">
      <g id="Search_icon" data-name="Search icon" transform="translate(0.001 0)" opacity="0.5">
        <path
          id="Ellipse_642"
          data-name="Ellipse 642"
          d="M9,1.5A7.5,7.5,0,1,0,16.5,9,7.508,7.508,0,0,0,9,1.5M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Z"
          transform="translate(-0.001 0)"
          fill="#333"
        />
        <path
          id="Ellipse_643"
          data-name="Ellipse 643"
          d="M2.5,0A2.5,2.5,0,1,1,0,2.5,2.5,2.5,0,0,1,2.5,0Z"
          transform="translate(15.999 15)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const CancelIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-x"
      viewBox="0 0 16 16"
    >
      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-x-lg"
      viewBox="0 0 16 16"
    >
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
    </svg>
  );
};

export const BackIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-caret-left-fill"
      viewBox="0 0 16 16"
    >
      <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"></path>
    </svg>
  );
};
export const FillUp = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-caret-up-fill"
      viewBox="0 0 16 16"
    >
      <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
    </svg>
  );
};

export const FillDown = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-caret-down-fill"
      viewBox="0 0 16 16"
    >
      <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
    </svg>
  );
};

export const DisableDeleteIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.24" height="24" viewBox="0 0 20.24 24">
      <g id="Group_4462" data-name="Group 4462" transform="translate(-108.999 -172.003)">
        <g id="trash-can-10416" transform="translate(108.999 172.003)">
          <path
            id="Path_156"
            data-name="Path 156"
            d="M48.776,52.948H38.467a2.343,2.343,0,0,1-2.317-2.228L35.123,32.83a.81.81,0,0,1,.212-.6.777.777,0,0,1,.571-.251h15.43a.779.779,0,0,1,.571.251.812.812,0,0,1,.213.6L51.093,50.72A2.343,2.343,0,0,1,48.776,52.948ZM36.738,33.583l.979,17.043a.759.759,0,0,0,.75.722H48.776a.758.758,0,0,0,.75-.721l.979-17.044Z"
            transform="translate(-33.502 -28.948)"
            fill="#9aa9a3"
          />
          <path
            id="Path_157"
            data-name="Path 157"
            d="M37.169,33.581H18.5a.8.8,0,0,1,0-1.6H37.17a.8.8,0,0,1,0,1.6Z"
            transform="translate(-17.714 -28.946)"
            fill="#9aa9a3"
          />
          <path
            id="Path_158"
            data-name="Path 158"
            d="M87.407,4.635H80.226a.792.792,0,0,1-.785-.8V2.344A2.324,2.324,0,0,1,81.74,0h4.153a2.324,2.324,0,0,1,2.3,2.344V3.835A.792.792,0,0,1,87.407,4.635Zm-6.4-1.6h5.611V2.344a.737.737,0,0,0-.729-.744H81.74a.737.737,0,0,0-.729.744v.691Z"
            transform="translate(-73.697)"
            fill="#9aa9a3"
          />
          <path
            id="Path_159"
            data-name="Path 159"
            d="M156.254,88.019h-.047a.8.8,0,0,1-.737-.846l.647-11.265a.786.786,0,0,1,.829-.752.8.8,0,0,1,.737.845l-.647,11.265A.791.791,0,0,1,156.254,88.019Z"
            transform="translate(-142.648 -68.021)"
            fill="#9aa9a3"
          />
          <path
            id="Path_160"
            data-name="Path 160"
            d="M75.049,88.02a.791.791,0,0,1-.782-.753L73.62,76a.785.785,0,1,1,1.566-.094l.647,11.265a.8.8,0,0,1-.737.846Z"
            transform="translate(-68.416 -68.022)"
            fill="#9aa9a3"
          />
          <path
            id="Path_161"
            data-name="Path 161"
            d="M118.8,88.024a.792.792,0,0,1-.785-.8V75.959a.785.785,0,1,1,1.569,0V87.224A.792.792,0,0,1,118.8,88.024Z"
            transform="translate(-108.685 -68.026)"
            fill="#9aa9a3"
          />
        </g>
      </g>
    </svg>
  );
};

export const EnableDeleteIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.24" height="24" viewBox="0 0 20.24 24">
      <g id="Group_4462" data-name="Group 4462" transform="translate(-108.999 -172.003)">
        <g id="trash-can-10416" transform="translate(108.999 172.003)">
          <path
            id="Path_156"
            data-name="Path 156"
            d="M48.776,52.948H38.467a2.343,2.343,0,0,1-2.317-2.228L35.123,32.83a.81.81,0,0,1,.212-.6.777.777,0,0,1,.571-.251h15.43a.779.779,0,0,1,.571.251.812.812,0,0,1,.213.6L51.093,50.72A2.343,2.343,0,0,1,48.776,52.948ZM36.738,33.583l.979,17.043a.759.759,0,0,0,.75.722H48.776a.758.758,0,0,0,.75-.721l.979-17.044Z"
            transform="translate(-33.502 -28.948)"
            fill="#ca353b"
          />
          <path
            id="Path_157"
            data-name="Path 157"
            d="M37.169,33.581H18.5a.8.8,0,0,1,0-1.6H37.17a.8.8,0,0,1,0,1.6Z"
            transform="translate(-17.714 -28.946)"
            fill="#ca353b"
          />
          <path
            id="Path_158"
            data-name="Path 158"
            d="M87.407,4.635H80.226a.792.792,0,0,1-.785-.8V2.344A2.324,2.324,0,0,1,81.74,0h4.153a2.324,2.324,0,0,1,2.3,2.344V3.835A.792.792,0,0,1,87.407,4.635Zm-6.4-1.6h5.611V2.344a.737.737,0,0,0-.729-.744H81.74a.737.737,0,0,0-.729.744v.691Z"
            transform="translate(-73.697)"
            fill="#ca353b"
          />
          <path
            id="Path_159"
            data-name="Path 159"
            d="M156.254,88.019h-.047a.8.8,0,0,1-.737-.846l.647-11.265a.786.786,0,0,1,.829-.752.8.8,0,0,1,.737.845l-.647,11.265A.791.791,0,0,1,156.254,88.019Z"
            transform="translate(-142.648 -68.021)"
            fill="#ca353b"
          />
          <path
            id="Path_160"
            data-name="Path 160"
            d="M75.049,88.02a.791.791,0,0,1-.782-.753L73.62,76a.785.785,0,1,1,1.566-.094l.647,11.265a.8.8,0,0,1-.737.846Z"
            transform="translate(-68.416 -68.022)"
            fill="#ca353b"
          />
          <path
            id="Path_161"
            data-name="Path 161"
            d="M118.8,88.024a.792.792,0,0,1-.785-.8V75.959a.785.785,0,1,1,1.569,0V87.224A.792.792,0,0,1,118.8,88.024Z"
            transform="translate(-108.685 -68.026)"
            fill="#ca353b"
          />
        </g>
      </g>
    </svg>
  );
};

export const EXLDownloadIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30.037" height="28.37" viewBox="0 0 30.037 28.37">
      <g id="noun-excel-1194546" transform="translate(-0.001)">
        <path
          id="Path_13743"
          data-name="Path 13743"
          d="M35.51,46.788V22.41H33.541c-5.056.913-10.1,1.758-15.171,2.635V48.1c4.992.881,10.047,1.763,15.071,2.676H35.5V46.788Zm-7.435-5.06a38.887,38.887,0,0,1-1.653-4.138c-.457,1.338-1.087,2.6-1.6,3.909-.722,0-1.443-.041-2.165-.069.845-1.658,1.662-3.329,2.535-4.973-.74-1.7-1.557-3.361-2.32-5.046l2.183-.123c.489,1.288,1.028,2.562,1.434,3.882.457-1.4,1.082-2.74,1.64-4.074q1.119-.078,2.242-.137-1.315,2.7-2.653,5.421c.913,1.827,1.827,3.676,2.74,5.521C29.66,41.838,28.869,41.788,28.075,41.728Z"
          transform="translate(-18.369 -22.41)"
          fill="#fff"
        />
        <path
          id="Path_13744"
          data-name="Path 13744"
          d="M57.72,29.33v1.749h3.494v2.58H57.72v1.416h3.494v2.58H57.72v1.416h3.494v2.576H57.72v1.416h3.494V45.62H57.72v1.5h3.494v2.5H57.72v1.749H69.786V29.33Zm9.4,20.3H62.045v-2.5h5.078Zm0-4H62.045v-2.58h5.078Zm0-4H62.045V39.067h5.078Zm0-4H62.045V35.071h5.078Zm0-4H62.045V31.079h5.078Z"
          transform="translate(-39.748 -26.17)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export const SiteTabIcon = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 32 32"
      height="200px"
      width="200px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M 12 5 L 12 13 L 15 13 L 15 15 L 5 15 L 5 19 L 2 19 L 2 27 L 10 27 L 10 19 L 7 19 L 7 17 L 15 17 L 15 19 L 12 19 L 12 27 L 20 27 L 20 19 L 17 19 L 17 17 L 25 17 L 25 19 L 22 19 L 22 27 L 30 27 L 30 19 L 27 19 L 27 15 L 17 15 L 17 13 L 20 13 L 20 5 Z M 14 7 L 18 7 L 18 11 L 14 11 Z M 4 21 L 8 21 L 8 25 L 4 25 Z M 14 21 L 18 21 L 18 25 L 14 25 Z M 24 21 L 28 21 L 28 25 L 24 25 Z"></path>
    </svg>
  );
};
